import type { FC } from 'react';

import { Radio } from '@motorway/mw-highway-code/alpha';

import { applyCypressData } from 'Utilities/helpers';

import type { DownloadCSVPopoverContentRadioButtonProps } from './DownloadCSVPopoverContentRadioButton.types';

import styles from './DownloadCSVPopoverContentRadioButton.module.scss';

export const DownloadCSVPopoverContentRadioButton: FC<DownloadCSVPopoverContentRadioButtonProps> = ({
	cypressId,
	id,
	label,
	onChange,
	selectedItemId,
}) => {
	return (
		<div className={styles.item}>
			<Radio
				fullWidth
				formProps={{
					input: {
						checked: selectedItemId === id,
						onChange: () => onChange(id),
						readOnly: true,
					},
				}}
				id={String(id)}
				label={label}
				variant="default"
				{...applyCypressData(cypressId)}
			/>
		</div>
	);
};
